// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  padding: 20px 0 32px;
}

.auth-shell {
  max-width: 720px;
  margin: 0 auto;
}

.auth-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.auth-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.auth-eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 12px;
  color: #6c757d;
}

.auth-title {
  margin: 0;
  font-size: 26px;
  font-family: "Work Sans", Arial, sans-serif;
}

.auth-subtitle {
  margin: 0;
  color: #4a5568;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-input-group {
  border: 1px solid #e3e7ef;
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fb;
}
.auth-input-group .input-group-text {
  background: transparent;
  border: none;
  color: var(--e-global-color-primary);
}
.auth-input-group .form-control {
  border: none;
  background: transparent;
  padding: 12px 14px;
}

.checkbox-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.auth-checkbox {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: start;
  padding: 6px 0;
  border: none;
  border-radius: 0;
  background: transparent;
}
.auth-checkbox.form-check {
  padding-left: 0;
  margin-bottom: 0;
}
.auth-checkbox .form-check-input {
  margin-top: 4px;
  margin-left: 0;
  position: relative;
}
.auth-checkbox .form-check-label {
  margin: 0;
  padding-left: 0;
  line-height: 1.5;
  color: #1f2937;
}
.auth-checkbox .form-check-label a {
  color: var(--e-global-color-primary);
  font-weight: 600;
  text-decoration: underline;
}

.form-error {
  color: #c44762;
  font-weight: 600;
  margin: -4px 4px 0;
}

.auth-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.auth-actions.only-primary {
  justify-content: flex-end;
}

.auth-footer {
  text-align: center;
  color: #4a5568;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.auth-footer .highlight {
  font-weight: 700;
  color: #1f2937;
}

@media (max-width: 576px) {
  .auth-card {
    padding: 18px;
  }
  .auth-title {
    font-size: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/auth/auth-shared.scss","webpack://./projects/public/src/app/components/forgotten-password/forgotten-password.component.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;ACAF;;ADGA;EACE,gBAAA;EACA,cAAA;ACAF;;ADGA;EACE,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ACAF;;ADGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACAF;;ADGA;EACE,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;ACAF;;ADGA;EACE,SAAA;EACA,eAAA;EACA,2CAAA;ACAF;;ADGA;EACE,SAAA;EACA,cAAA;ACAF;;ADGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACAF;;ADGA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;ACAF;ADEE;EACE,uBAAA;EACA,YAAA;EACA,oCAAA;ACAJ;ADGE;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;ACDJ;;ADKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACFF;;ADKA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;ACFF;ADIE;EACE,eAAA;EACA,gBAAA;ACFJ;ADKE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;ACHJ;ADME;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ACJJ;ADMI;EACE,oCAAA;EACA,gBAAA;EACA,0BAAA;ACJN;;ADSA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;ACNF;;ADSA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACNF;;ADSA;EACE,gBAAA;EACA,cAAA;ACNF;;ADSA;EACE;IACE,aAAA;ECNF;EDSA;IACE,eAAA;ECPF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap');\n\n.auth-page {\n  padding: 20px 0 32px;\n}\n\n.auth-shell {\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.auth-card {\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);\n  padding: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.auth-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.auth-eyebrow {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.auth-title {\n  margin: 0;\n  font-size: 26px;\n  font-family: 'Work Sans', Arial, sans-serif;\n}\n\n.auth-subtitle {\n  margin: 0;\n  color: #4a5568;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-input-group {\n  border: 1px solid #e3e7ef;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f8f9fb;\n\n  .input-group-text {\n    background: transparent;\n    border: none;\n    color: var(--e-global-color-primary);\n  }\n\n  .form-control {\n    border: none;\n    background: transparent;\n    padding: 12px 14px;\n  }\n}\n\n.checkbox-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.auth-checkbox {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: start;\n  padding: 6px 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n\n  &.form-check {\n    padding-left: 0;\n    margin-bottom: 0;\n  }\n\n  .form-check-input {\n    margin-top: 4px;\n    margin-left: 0;\n    position: relative;\n  }\n\n  .form-check-label {\n    margin: 0;\n    padding-left: 0;\n    line-height: 1.5;\n    color: #1f2937;\n\n    a {\n      color: var(--e-global-color-primary);\n      font-weight: 600;\n      text-decoration: underline;\n    }\n  }\n}\n\n.form-error {\n  color: #c44762;\n  font-weight: 600;\n  margin: -4px 4px 0;\n}\n\n.auth-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.auth-actions.only-primary {\n  justify-content: flex-end;\n}\n\n.auth-footer {\n  text-align: center;\n  color: #4a5568;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.auth-footer .highlight {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n@media (max-width: 576px) {\n  .auth-card {\n    padding: 18px;\n  }\n\n  .auth-title {\n    font-size: 22px;\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap\");\n.auth-page {\n  padding: 20px 0 32px;\n}\n\n.auth-shell {\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.auth-card {\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);\n  padding: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.auth-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.auth-eyebrow {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.auth-title {\n  margin: 0;\n  font-size: 26px;\n  font-family: \"Work Sans\", Arial, sans-serif;\n}\n\n.auth-subtitle {\n  margin: 0;\n  color: #4a5568;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-input-group {\n  border: 1px solid #e3e7ef;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f8f9fb;\n}\n.auth-input-group .input-group-text {\n  background: transparent;\n  border: none;\n  color: var(--e-global-color-primary);\n}\n.auth-input-group .form-control {\n  border: none;\n  background: transparent;\n  padding: 12px 14px;\n}\n\n.checkbox-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.auth-checkbox {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: start;\n  padding: 6px 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n}\n.auth-checkbox.form-check {\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.auth-checkbox .form-check-input {\n  margin-top: 4px;\n  margin-left: 0;\n  position: relative;\n}\n.auth-checkbox .form-check-label {\n  margin: 0;\n  padding-left: 0;\n  line-height: 1.5;\n  color: #1f2937;\n}\n.auth-checkbox .form-check-label a {\n  color: var(--e-global-color-primary);\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.form-error {\n  color: #c44762;\n  font-weight: 600;\n  margin: -4px 4px 0;\n}\n\n.auth-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.auth-actions.only-primary {\n  justify-content: flex-end;\n}\n\n.auth-footer {\n  text-align: center;\n  color: #4a5568;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.auth-footer .highlight {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n@media (max-width: 576px) {\n  .auth-card {\n    padding: 18px;\n  }\n  .auth-title {\n    font-size: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
